"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createStore;

function createStore(initialState) {
  var state = initialState;
  var listeners = [];

  function dispatch() {
    listeners.forEach(function (listener) {
      return listener();
    });
  }

  return {
    getState: function getState() {
      return state;
    },
    setState: function setState(nextState) {
      state = nextState;
      dispatch();
    },
    subscribe: function subscribe(listener) {
      listeners.push(listener);
      return function unsubcribe() {
        listeners.splice(listeners.indexOf(listener), 1);
      };
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/react-instantsearch-core/dist/cjs/core/createStore.js
// module id = 1055
// module chunks = 142807904292071